export const formatNumber = (item: string | number | undefined | null, defaultValueReturn = 0) => {
  return item ? Number(item)?.toLocaleString() : defaultValueReturn;
};
